const commonConstants = {
	baseUrl: process.env.VUE_APP_SERVER_BASE_URL,
	fileUploadUrl: process.env.VUE_APP_SERVER_BASE_URL + "/file",
	fileDownloadUrl: (id)=>process.env.VUE_APP_SERVER_HOST+process.env.VUE_APP_SERVER_BASE_URL + `/file/${id}`,
	fileDeleteUrl: process.env.VUE_APP_SERVER_BASE_URL + "/file"
};

export const localStorageKey = {
	MENU: 'menu',
	INPUT_CHOICE: 'inputChoice'
}

export const lang = {
	EN: 'EN',
	CN: 'CN',
}

export default commonConstants;
